exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-info[data-v-1c09bde9]{color:#fff;background-color:#34cee6;border:0;font-family:Patua One,cursive;padding:15px}.card-body[data-v-1c09bde9]{padding:20px;margin:20px;background:#fff;border-radius:15px}.p-1[data-v-1c09bde9]{padding:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c09bde9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/startPage/Faq.vue
// module id = 437
// module chunks = 0